'use client';
import React, { useCallback, useState } from 'react';
import { AuthModal } from './AuthModal';
import { AuthMode, RequestAuthEvent } from '@benzinga/session';
import Hooks from '@benzinga/hooks';
import { AuthenticationManager } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';

export const AuthPortal = () => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [authMode, setAuthMode] = useState<AuthMode>('login');
  const session = React.useContext(SessionContext);

  const openModal = useCallback((mode: AuthMode): void => {
    setAuthMode(mode);
    setModalIsOpen(true);
  }, []);

  const closeModal = useCallback((): void => {
    setModalIsOpen(false);
  }, []);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Hooks.useSubscriber(session.getManager(AuthenticationManager), (event: RequestAuthEvent) => {
    if (event.type === 'request_auth') {
      openModal(event.mode);
    }
  });

  return <AuthModal authMode={authMode} isOpen={modalIsOpen} onRequestClose={closeModal} />;
};
